import { z } from 'zod';

const compliance = z
    .object({
        CE: z.boolean().default(false),
        UL: z.boolean().default(false),
        CSA: z.boolean().default(false),
        CCC: z.boolean().default(false),
        currentOS: z.boolean().default(false),
        emergeAlliance: z.boolean().default(false),
        ODCA: z.boolean().default(false),
        other: z.boolean().default(false),
        otherInput: z.string().optional(),
    })
    .default({});

export { compliance };
